export const learnersStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'EMIS Number', key: 'primaryInstitution.emisNumber' },
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'Tracking ID', key: 'trackingId' },
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Disability', key: 'disability' },
  { label: 'Disability Types', key: 'disabilityTypes[0].name' },
  { label: 'OVC', key: 'ovc' },
  { label: 'Pre-Primary Experience', key: 'prePrimaryExperience' },
  { label: 'Grades', key: 'grades' },
  { label: 'Years in Grade', key: 'yearsInGrade' },
  { label: 'Years in Phase', key: 'yearsInPhase' },
  { label: 'District', key: 'district.name' },
  { label: 'Additional Institutions', key: 'additionalInstitutions' },
  { label: 'Date Exited', key: 'dateExited' },
  { label: 'Reason for Exit', key: 'reasonForTermination.name' },
  { label: 'Caregiver Type', key: 'careGiverType' },
  { label: 'Caregiver Relationship', key: 'careGiverRelationship' },
  { label: 'Caregiver Name', key: 'careGiverName' },
  { label: 'Caregiver Surname', key: 'careGiverSurname' },
  { label: 'Caregiver Gender', key: 'careGiverGender.name' },
  { label: 'Caregiver National ID', key: 'careGiverNationalId' },
  { label: 'Caregiver Marital Status', key: 'careGiverMaritalStatus' },
  { label: 'Caregiver Contact Number', key: 'careGiverContactNumber' },
  { label: 'Caregiver Email Address', key: 'careGiverEmailAddress' },
  { label: 'Caregiver Physical Address', key: 'careGiverPhysicalAddress' },
  { label: 'Caregiver Occupation', key: 'careGiverOccupation' },
  { label: 'Caregiver Employer', key: 'careGiverEmployer' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'schoolSubject' }, // to confirm
  { label: 'Other Subject', key: 'otherSubject' }, // to confirm
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const schoolOfficialsStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'EMIS Number', key: 'primaryInstitution.emisNumber' },
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'Persal Number', key: 'persalNumber' },
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Personnel Position', key: 'personnelPosition.name' },
  { label: 'Post Level', key: 'postLevel' },
  { label: 'Date Started', key: 'dateStarted' },
  { label: 'Nature of Employment', key: 'natureOfEmployment.name' },
  { label: 'Renumeration Source', key: 'renumerationSource.name' },
  { label: 'Educator Level', key: 'educatorLevel.name' },
  { label: 'Years of Experience', key: 'yearsOfExperience' },
  { label: 'Lead Educator', key: 'leadEducator' },
  { label: 'ICT Skill', key: 'ictSkill.name' },
  { label: 'Highest Qualification', key: 'highestQualification.name' },
  { label: 'Multigrade', key: 'multiGrade' },
  { label: 'Subjects', key: 'subjects' },
  { label: 'Grades', key: 'grades' },
  { label: 'District', key: 'district.name' },
  { label: 'Additional Institutions', key: 'additionalInstitutions' },
  { label: 'Date Exited', key: 'dateExited' },
  { label: 'Reason for Exit', key: 'reasonForTermination.name' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'schoolSubject' },
  { label: 'Other Subject', key: 'otherSubject' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const districtOfficialsStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'Persal Number', key: 'persalNumber' },
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Personnel Position', key: 'personnelPosition.name' },
  { label: 'Personnel Position Other', key: 'personnelPositionOther' },
  { label: 'Designation', key: 'designation' },
  { label: 'Phase', key: 'phase.name' },
  { label: 'Subjects', key: 'subjects' },
  { label: 'Additional Institutions', key: 'additionalInstitutions' },
  { label: 'Date Exited', key: 'dateExited' },
  { label: 'Reason for Exit', key: 'reasonForTermination.name' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'schoolSubject' },
  { label: 'Other Subject', key: 'otherSubject' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const socialServicesProfessionalsStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'Persal Number', key: 'persalNumber' },
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Personnel Position', key: 'personnelPosition.name' },
  { label: 'Personnel Position Other', key: 'personnelPositionOther' },
  { label: 'Designation', key: 'designation' },
  { label: 'Phase', key: 'phase.name' },
  { label: 'Subjects', key: 'subjects' },
  { label: 'Additional Institutions', key: 'additionalInstitutions' },
  { label: 'Date Exited', key: 'dateExited' },
  { label: 'Reason for Exit', key: 'reasonForTermination.name' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const provincialOfficialsStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'Persal Number', key: 'persalNumber' },
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Country', key: 'country.name' },
  { label: 'Province', key: 'province.name' },
  { label: 'Region', key: 'region.name' },
  { label: 'Branch', key: 'branch' },
  { label: 'Personnel Position', key: 'personnelPosition.name' },
  { label: 'Personnel Position Other', key: 'personnelPositionOther' },
  { label: 'Designation', key: 'designation' },
  { label: 'Additional Institutions', key: 'additionalInstitutions' },
  { label: 'Date Exited', key: 'dateExited' },
  { label: 'Reason for Exit', key: 'reasonForTermination.name' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'schoolSubject' },
  { label: 'Other Subject', key: 'otherSubject' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const nationalOfficialsStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'Persal Number', key: 'persalNumber' },
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Country', key: 'country.name' },
  { label: 'Branch', key: 'branch' },
  { label: 'Personnel Position', key: 'personnelPosition.name' },
  { label: 'Personnel Position Other', key: 'personnelPositionOther' },
  { label: 'Designation', key: 'designation' },
  { label: 'Additional Institutions', key: 'additionalInstitutions' },
  { label: 'Date Exited', key: 'dateExited' },
  { label: 'Reason for Exit', key: 'reasonForTermination.name' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'schoolSubject' },
  { label: 'Other Subject', key: 'otherSubject' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const communityMembersStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'EMIS Number', key: 'primaryInstitution.emisNumber' },
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Community Type', key: 'communityType.name' },
  { label: 'Country', key: 'country.name' },
  { label: 'Province', key: 'province.name' },
  { label: 'District Municipality', key: 'districtMunicipality' }, // to be created
  { label: 'Local Municipality', key: 'localMunicipality.localMunicipality' },
  { label: 'Role', key: 'role.name' },
  { label: 'District', key: 'district.name' },
  { label: 'Additional Institutions', key: 'additionalInstitutions' },
  { label: 'Date Exited', key: 'dateExited' },
  { label: 'Reason for Exit', key: 'reasonForTermination.name' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'schoolSubject' },
  { label: 'Other Subject', key: 'otherSubject' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const practitionersStakeholderHeaders = [
  { label: 'Stakeholder ID', key: 'id' }, // system ID
  { label: 'EMIS Number', key: 'primaryInstitution.emisNumber' },
  { label: 'Institution Name', key: 'primaryInstitution.name' }, // primary institution
  { label: 'First Name', key: 'firstName' },
  { label: 'Last Name', key: 'lastName' },
  { label: 'National ID', key: 'nationalID' },
  { label: 'Gender', key: 'gender.name' },
  { label: 'Date of Birth', key: 'dateOfBirth' },
  { label: 'Population Group', key: 'populationGroup.name' },
  { label: 'Home Language', key: 'homeLanguage.name' },
  { label: 'Contact Number', key: 'contactNumber' },
  { label: 'Email Address', key: 'emailAddress' },
  { label: 'Programme', key: 'programmeName' },
  { label: 'Service Provider', key: 'serviceProviderName' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionName' },
  { label: 'School Subject', key: 'schoolSubject' },
  { label: 'Other Subject', key: 'otherSubject' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Stakeholder Type', key: 'type.name' },
];

export const stakeholdersHeaders = {
  Learners: learnersStakeholderHeaders,
  'School Officials': schoolOfficialsStakeholderHeaders,
  'District Officials': districtOfficialsStakeholderHeaders,
  'Provincial Officials': provincialOfficialsStakeholderHeaders,
  'National Officials': nationalOfficialsStakeholderHeaders,
  'Social Services Professionals': socialServicesProfessionalsStakeholderHeaders,
  Practitioners: practitionersStakeholderHeaders,
};

export const schoolInstitutionHeaders = [
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Institution Type', key: 'institutionType' },
  { label: 'Institution Name', key: 'name' },
  { label: 'Emis Number', key: 'emisNumber' },
  { label: 'Province', key: 'province' },
  { label: 'Region', key: 'region' },
  { label: 'District', key: 'district' },
  { label: 'Circuit', key: 'circuit' },
  { label: 'Education Sector', key: 'sector' },
  { label: 'School Phase', key: 'phase' },
  { label: 'Specialization', key: 'specialization' },
  { label: 'Specialization Group', key: 'specializationGroup' },
  { label: 'Section 21', key: 'section21' },
  { label: 'Quintile', key: 'quintile' },
  { label: 'Location', key: 'urbanRural' },
  { label: 'No Fee School', key: 'customNoFeeSchool' },
  { label: 'Physical Address', key: 'streetAddress' },
  { label: 'Municipality', key: 'districtMunicipalityName' },
  { label: 'GIS Longitude', key: 'gisLongitude' },
  { label: 'GIS Latitude', key: 'gisLatitude' },
  { label: 'School Contact Number', key: 'telephone' },
  { label: 'School Email Address', key: 'email' },
  { label: 'Principal Name', key: 'addressee' },
  { label: 'Principal Contact Number', key: 'principalContactNumber' },
  { label: 'Principal Email Address', key: 'principalEmailAddress' },
  { label: 'Circuit Manager Name', key: 'circuitManagerName' },
  { label: 'Circuit Manager Contact Number', key: 'circuitManagerContactNumber' },
  { label: 'Circuit Manager Email Address', key: 'circuitManagerEmailAddress' },
  { label: 'Number of Educators', key: 'educatorNumber' },
  { label: 'Number of Learner', key: 'learnerNumber' },
  { label: 'Status', key: 'status' },
  { label: 'Previous EMIS Number', key: 'oldEmisNumber' },
  { label: 'New EMIS Number', key: 'newEmisNumber' },
  { label: 'Intervention Role', key: 'interventionRole' },
];

const districtOfficeInstitutionHeaders = [
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Institution Type', key: 'institutionType' },
  { label: 'Institution Name', key: 'name' },
  { label: 'Country', key: 'country' },
  { label: 'Province', key: 'province' },
  { label: 'Physical Address', key: 'streetAddress' },
  { label: 'Postal Address', key: 'postalAddress' },
  { label: 'GIS Latitude', key: 'gisLatitude' },
  { label: 'GIS Longitude', key: 'gisLongitude' },
  { label: 'District Contact Number', key: 'districtContactNumber' },
  { label: 'District Email Address', key: 'districtEmailAddress' },
  { label: 'Contact Person', key: 'contactPerson' },
  { label: 'Contact Person Cell Number', key: 'contactNumber' },
  { label: 'Contact Person Email Address', key: 'contactEmail' },
  { label: 'Number of Circuits', key: 'numberOfCircuits' },
  { label: 'Number of Schools', key: 'numberOfSchools' },
  { label: 'Intervention Role', key: 'interventionRole' },
];

const provincialOfficeInstitutionHeaders = [
  { label: 'Programme', key: 'programmeNames' },
  { label: 'Service Provider', key: 'serviceProviderNames' },
  { label: 'Intervention ID', key: 'interventionIds' },
  { label: 'Intervention', key: 'interventionNames' },
  { label: 'School Subject', key: 'interventionSubjects' },
  { label: 'Other Subject', key: 'interventionFocusSubjects' },
  { label: 'Intervention Grade', key: 'interventionGrades' },
  { label: 'Institution Type', key: 'institutionType' },
  { label: 'Institution Name', key: 'name' },
  { label: 'Country', key: 'country' },
  { label: 'Physical Address', key: 'streetAddress' },
  { label: 'Postal Address', key: 'postalAddress' },
  { label: 'GIS Latitude', key: 'gisLatitude' },
  { label: 'GIS Longitude', key: 'gisLongitude' },
  { label: 'Website', key: 'website' },
  { label: 'Office Contact Number', key: 'officeContactNumber' },
  { label: 'Office Email Address', key: 'officeEmailAddress' },
  { label: 'Head of Department', key: 'hod' },
  { label: 'Head of Department Contact Number', key: 'hodContact' },
  { label: 'Head of Department Email Address', key: 'hodEmail' },
  { label: 'Contact Person', key: 'contactPerson' },
  { label: 'Contact Person Cell Number', key: 'contactNumber' },
  { label: 'Contact Person Email Address', key: 'contactEmail' },
  { label: 'Number of Districts', key: 'numberOfDistricts' },
  { label: 'Number of Circuits', key: 'numberOfCircuits' },
  { label: 'Number of Schools', key: 'numberOfSchools' },
  { label: 'Intervention Role', key: 'interventionRole' },
];

export const institutionHeaders = {
  School: schoolInstitutionHeaders,
  'District Office': districtOfficeInstitutionHeaders,
  'Provincial Office': provincialOfficeInstitutionHeaders,
  'Country Office': provincialOfficeInstitutionHeaders,
  'Regional Office': provincialOfficeInstitutionHeaders,
  'Circuit Office': provincialOfficeInstitutionHeaders,
  'Cluster Office': provincialOfficeInstitutionHeaders,
};

export const interventionHeaders = [
  { label: 'Programme', key: 'programme.name' },
  { label: 'Service Provider', key: 'serviceProviders' },
  { label: 'Intervention ID', key: 'id' },
  { label: 'Intervention Name', key: 'name' },
  { label: 'Description', key: 'description' },
  { label: 'Theory Of Change', key: 'theoryOfChange' },
  { label: 'Treatment Group', key: 'treatmentGroup.name' },
  { label: 'Beneficiaries', key: 'treatmentGroups.length' },
  { label: 'Intervention Type', key: 'type.name' },
  { label: 'Intervention Focus', key: 'foci' },
  { label: 'Grade', key: 'grades' },
  { label: 'School Subject', key: 'subjects' },
  { label: 'Other Subjects', key: 'subject.name' },
  { label: 'Accredited', key: 'accredited' },
  { label: 'Accreditation', key: 'accreditation' },
  { label: 'Intervention Phase', key: 'phase.name' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endDate' },
  { label: 'Class', key: 'class.name' },
  { label: 'Impact Themes', key: 'impactThemes' },
  { label: 'Outcome Themes', key: 'outcomeThemes' },
];
